define('models/StoreAutocompleteCollection',['underscore','backbone','app','string','StringSimplification'],function (_,Backbone,app,S,Simplification) {
    //
    // Collection StoreAutocomplete
    //

    return Backbone.Collection.extend({

        comparator:'rank',
        request:function(options){
            var collection = this,
                input = S(options.input).trim().s,
                usePlaceFetch = options.usePlaceFetch,
                selectAll = input == '', // si la recherche est vide, on selectionne tout
                inputSimplification = selectAll ? 0 : Simplification(input),
                inputRegExp = selectAll ? 0 : new RegExp(inputSimplification,'ig'),
                stores = app.getStores(),
                results = [];
                stores.each(function(store){
                    var match = selectAll, rank,
                        isAvailable = store.isAvailable(true);
                    if(!match){
                        var autocompletePattern = store.getAutocompletePattern(); // disponible pour la VAE
                        match = !!autocompletePattern.match(inputRegExp) && isAvailable;
                    }
                    match = match && isAvailable;
                    if(match){
                        rank = options.useGeolocation ? parseFloat(store.getDistance())*1000 : false;
                        if(!rank){
                            rank = Simplification(store.getName());
                        }
                        // si le resultat est valide
                        var result = {
                            type:'store',
                            id_store:store.id,
                            description:store.getName(),
                            rank:rank,
                            usePlaceFetch:usePlaceFetch
                        };
                       results.push(result);
                    }

                });
                collection.set(results);
                collection.trigger('sync',collection);
        }
    });
});

